import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'lin-layout-form-sections-wrapper',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['form-sections-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormSectionsWrapperComponent {
  @HostBinding('class.double')
  get double() {
    return this.layout === 'double'
  }

  @HostBinding('class.triple')
  get triple() {
    return this.layout === 'triple'
  }

  @Input() layout: 'double' | 'triple'
}
